import { render, staticRenderFns } from "./CreateMenuElement.vue?vue&type=template&id=7591ab42&"
import script from "./CreateMenuElement.vue?vue&type=script&lang=js&"
export * from "./CreateMenuElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports